import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '@services/local-storage-service';

const REDIRECT_URL_KEY = 'CureSkin/redirectUrl';
/** Read by `app.component` on back press to force home instead of unwinding history. */
const BACK_TO_HOME_PARAM = 'back=home';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private readonly localStorageService = inject(LocalStorageService);
  private readonly router = inject(Router);

  /**
   * Persist the current route as the redirect url, so a flow that navigates away (photo capture, chat
   * CTA) can return to it. `ConnectionService.redirectToLastKnowLocation` consumes what this writes.
   */
  persistRedirectUrl(): void {
    const url: string = this.router.url;
    const separator: string = url.includes('?') ? '&' : '?';
    this.localStorageService.setValue(REDIRECT_URL_KEY, `${url}${separator}${BACK_TO_HOME_PARAM}`);
  }

  getRedirectUrl(defaultUrl: string = ''): string {
    return this.localStorageService.getValue(REDIRECT_URL_KEY) || defaultUrl;
  }

  clearRedirectUrl(): void {
    this.localStorageService.delete(REDIRECT_URL_KEY);
  }
}
